import apiClient from "./index";

export const orderApi = {
	// 주문하기
	createOrder: (orderData) => {
		return apiClient.post('/orders', orderData);
	},

	// 주문 내역 조회
	getOrderList: () => {
		return apiClient.get('/orders');
	},

	// 주문 상세 조회
	getOrderDetail: (orderNumber) => {
		return apiClient.get(`/orders/${ orderNumber }`);
	},

	// 주문 취소
	cancelOrder: (orderNumber) => {
		return apiClient.patch(`/orders/${ orderNumber }/cancel`);
	},
	
	// 배송지 변경
	updateDeliveryAddress: (orderNumber, addressData) => {
		return apiClient.patch(`/orders/${ orderNumber }/shipping`, addressData);
	}
}
